



































































import {Component, Prop} from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'
import TinyMce from '@/components/admin/TinyMce.vue'
import Job from '@/models/Job'
import Post from '@/models/Post'

@Component({
  components: {
    TinyMce
  }
})
export default class JobForm extends VueBase {
  @Prop(Object) post!: Post
  @Prop(Object) value!: Job
  showed = false
  uniqueId = this.uId()

  toggle(): void {
    this.showed = !this.showed
  }

  uId(): string {
    return Date.now().toString(16) + Math.floor(1000 * Math.random()).toString(16)
  }
}
